import type React from "react";
import { Box } from "@mui/material";

interface StagingTagProps {
  isStaging: boolean;
  borderColor: string;
  badgeColor: string;
  badgeText: string;
}

export const StagingTag: React.FC<StagingTagProps> = ({
  isStaging,
  borderColor,
  badgeColor,
  badgeText,
}) => {
  if (!isStaging) return null;

  return (
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: -36,
        transform: "translateY(-50%) rotate(-90deg)",
        bgcolor: badgeColor,
        color: "#000",
        px: 2,
        py: 1,
        fontWeight: 900,
        fontSize: "0.8rem",
        letterSpacing: "2px",
        textTransform: "uppercase",
        borderRadius: "0 0 8px 8px",
        boxShadow: "0 4px 12px rgba(251, 191, 36, 0.5)",
        zIndex: 10,
        whiteSpace: "nowrap",
        border: "2px solid #000",
      }}
    >
      {badgeText}
    </Box>
  );
};
